import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

interface VoiceMessage {
  description: string;
  header: string;
  type: string;
  canBeEnabled: boolean;
  permission: string;
}

interface MessageSeparator {
  isSeparator: boolean;
  header: string;
}

@Component({
  selector: 'cc-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent implements OnInit {
  @Input() voiceMailOnly = false;
  @Input() msisdnId;
  @Input() numberConfig;
  @Input() messages: (VoiceMessage | MessageSeparator)[];
  @Input() title: string;
  @Output() inboundSettingsChanged = new EventEmitter();
  @Output() settingsChanged = new EventEmitter();
  public opened = [];
  public allOpened: boolean;

  constructor() {}

  ngOnInit() {
    this.opened = new Array(this.messages.length).fill(false);
  }

  checkIsAllOpened() {
    setTimeout(() => {
      this.allOpened = this.opened.every(el => el);
    }, 0);
  }

  openAll() {
    this.opened = this.allOpened ? this.opened.map(() => false) : this.opened.map(() => true);
    this.checkIsAllOpened();
  }

  changeOpen(value, index) {
    this.opened[index] = value;
    this.checkIsAllOpened();
  }
}
